import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";

const skills = [
  {
    category: "Frontend",
    icon: "⚛️",
    color: "bg-gradient-to-br from-gold to-gold-rose",
    techs: [
      "React",
      "React Native",
      "Redux",
      "Next.js",
      "Expo",
      "Tailwind CSS",
      "Framer Motion",
    ],
  },
  {
    category: "Backend",
    icon: "⚙️",
    color: "bg-gradient-to-br from-navy to-navy-dark",
    techs: ["Node.js", "Express", "REST API"],
  },
  {
    category: "Database",
    icon: "🗄️",
    color: "bg-gradient-to-br from-sage to-sage-dark",
    techs: ["MongoDB", "Mongoose"],
  },
  {
    category: "Tools",
    icon: "🛠️",
    color: "bg-gradient-to-br from-terracotta to-terracotta-dark",
    techs: ["Git", "GitHub", "VS Code", "Postman", "Figma"],
  },
];

const Services = () => {
  return (
    <section className="section" id="services">
      <div className="container mx-auto">
        {/* Header */}
        <motion.div
          variants={fadeIn("up", 0.3)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-5 py-2 bg-white border border-stone/40 font-mono font-medium text-sm tracking-wider mb-4 shadow-elegant">
            COMPÉTENCES
          </span>
          <h2 className="h2">
            Ma Stack
            <br />
            <span className="relative inline-block">
              Technique
              <span className="absolute -bottom-2 left-0 w-full h-3 bg-gradient-to-r from-sage/40 to-navy/40 -z-10 blur-sm" />
            </span>
          </h2>
          <p className="text-lg text-charcoal/70 mt-6 max-w-2xl mx-auto">
            Technologies et outils que je maîtrise pour créer des applications
            web modernes et performantes
          </p>
        </motion.div>

        {/* Skills Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {skills.map((skill, index) => (
            <motion.div
              key={skill.category}
              variants={fadeIn("up", 0.3 + index * 0.1)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.3 }}
              className="card-hover group"
            >
              {/* Icon badge */}
              <div
                className={`absolute -top-4 -right-4 w-16 h-16 ${skill.color} border border-white/30 flex items-center justify-center shadow-elegant group-hover:shadow-elegant-lg transition-all`}
              >
                <span className="text-3xl">{skill.icon}</span>
              </div>

              {/* Category title */}
              <h3 className="h4 mb-6">{skill.category}</h3>

              {/* Technologies tags */}
              <div className="flex flex-wrap gap-2">
                {skill.techs.map((tech, techIndex) => (
                  <span
                    key={tech}
                    className="inline-block px-3 py-2 bg-sand-light border border-sand-dark/30 font-mono text-xs font-medium hover:bg-sand hover:border-sand-dark/50 hover:shadow-elegant transition-all"
                    style={{
                      animationDelay: `${techIndex * 50}ms`,
                    }}
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Additional Info */}
        <motion.div
          variants={fadeIn("up", 0.8)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }}
          className="mt-12 text-center"
        >
          <div className="inline-block p-6 bg-white border border-stone/30 shadow-elegant">
            <p className="font-mono font-medium text-sm">
              💡 Toujours en apprentissage de nouvelles technologies et
              frameworks
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
